import * as TypesExams from '../types/types_exams'
import Vue from 'vue'

export default {
  state: {
    profile: {}
  },
  mutations: {},
  actions: {
    /**
     * 获取历次考试列表
     * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=49119486#v3-%E8%80%83%E8%AF%95API-%E8%8E%B7%E5%8F%96%E5%8E%86%E6%AC%A1%E8%80%83%E8%AF%95%E5%88%97%E8%A1%A8
     */
    [TypesExams.EXAMS_GET_LIST] (ctx) {
      return Vue.http.get('/v1/exam-proxy/v3/3rdExam/3rd-list').then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      }).catch(err => {
        // 统一错误处理
        throw err
      })
    },
    [TypesExams.EXAMS_GET_BE_LIST] (ctx) {
      return Vue.http.get('/v1/exam-proxy/v3/exam/list').then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      }).catch(err => {
        // 统一错误处理
        throw err
      })
    },
    [TypesExams.GET_MEMBERS] (ctx) { // 获取是否是会员
      return Vue.http.get('/v1/be-proxy/v2/user-center/payment-info').then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      }).catch(err => {
        // 统一错误处理
        throw err
      })
    },
    [TypesExams.GET_MEMBER_SHIPS] (ctx) { // 获取会员资格
      return Vue.http.get('/v1/be-proxy/v2/payments/goods-list').then(function (resp) {
        return Vue.checkResp(resp)
      }).then(data => {
        return data
      }).catch(err => {
        // 统一错误处理
        throw err
      })
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_exams.js